<template>
	<div class="section-header" pdf-truncation-check-point>
		<span class="section-number">{{ number }}</span>
		<h3 class="section-title">{{ title }}</h3>
	</div>
</template>

<script>
export default {
	name: 'SectionHeader',
	props: {
		number: { type: [String, Number], required: true },
		title: { type: String, required: true },
		icon: { type: String, default: '' },
	},
}
</script>

<style scoped lang="scss">
.section-header {
	display: flex;
	align-items: center;
	margin-bottom: var(--report-grid-gap);
	padding: 10px 0 5px;

	.section-number {
		background: #4c6bff;
		color: #fff;
		width: 32px;
		height: 32px;
		border-radius: 0 6px 0 6px;
		font-size: 16px;
		font-weight: bold;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 12px;
	}

	.section-title {
		font-size: 15px;
		font-weight: bold;
		color: #303133;
		margin: 0;
	}
}
</style>
